/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPaperclip = createReactComponent("outline", "paperclip", "IconPaperclip", [["path", { "d": "M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9l6.5 -6.5", "key": "svg-0" }]]);

export { IconPaperclip as default };
//# sourceMappingURL=IconPaperclip.mjs.map
